import { Badge, Button, Grid, Group, Loader, Paper, Text } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import moment from 'moment';
import React from 'react';
import Calendar from '../calendar';
import { GET_ALL_EVENTS } from '../../services/events';
import InputField, { InputFieldTypes } from '../input_field';
import Table from '../table';
import ThemePaper from '../theme_paper';

const COLUMNS = [
    {title: "Início", key: 'start', render: (item) => item.data.dataHoraInicio ?
        moment(item.data.dataHoraInicio).format("DD/MM/YYYY HH:mm")
        : null},
    {title: "Fim", key: 'finish', render: (item) => item.data.dataHoraFim ?
        moment(item.data.dataHoraFim).format("DD/MM/YYYY HH:mm")
        : null},
    {title: "Título", key: 'description', render: (item) => item.data.descricaoTipo},
    {title: "Órgão(s)", key: 'setor', render: (item) => item.data.orgaos.map(o => `${o.sigla} - ${o.nome}`)},
    {title: "Local", key: 'local', render: (item) => item.data.localCamara?.nome},
    {title: "Situação", key: 'situacao'},
]

interface ListProps{}
interface ListHandle{
    refresh: () => void;
}

const List : React.ForwardRefRenderFunction<ListHandle, ListProps> = ({}, ref) => {
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState<any>(null);
    const [viewMode, setViewMode] = React.useState('list');
    // const [viewMode, setViewMode] = React.useState('calendar');
    const [dataFilter, setDataFilter] = React.useState<{[key: string]: any[]}>({});
    const [filters, setFilters] = React.useState({
        start: moment().startOf("week").add(1, "days").format("YYYY-MM-DD"),
        finish: moment().endOf("week").add(1, "days").format("YYYY-MM-DD"),
    });
    const keyFilter = [
        `${filters.start}-${filters.finish}`
    ].join(";")

    const loadUsers = () => {
        setError(null);
        setLoading(true);

        GET_ALL_EVENTS(filters)
        .then((events: any[]) => {
            setLoading(false);
            setDataFilter(df => ({...df, [keyFilter]: events}));
        })
        .catch(err => {
            setLoading(false);
            setError(err.message);
            showNotification({message: err.message, color: 'red'});
        })
    }

    const refresh = () => { loadUsers(); }

    const data = dataFilter[keyFilter] || [];

    React.useEffect(refresh, []);

    React.useImperativeHandle(ref, () => ({
        refresh: () => { refresh(); }
    }));

    return <>
            {/* <Grid mb="xs">
                <Grid.Col md={10} sm={12}>
                </Grid.Col>
                <Grid.Col md={2} sm={12}>
                    <Button
                        fullWidth
                        variant="subtle"
                        onClick={() => setViewMode(viewMode === 'list' ? 'calendar' : 'list')}
                    >{viewMode === 'list' ? 'Ver Calendário' : 'Ver Lista'}</Button>
                </Grid.Col>
            </Grid> */}
            {/*  */}

            {viewMode === 'list' && <div>
                {loading && <Loader />}
                <Grid mb="xs">
                    <Grid.Col md={8} sm={12}>
                        {data
                        // .reduce((pv, item) => pv.concat(item.themes.map(th => ({event: item, theme: th}))), [])
                        // .map(({theme}) => (
                        //     <ThemePaper
                        //         theme={theme}
                        //     />
                        // ))}
                        .map((item) => <Paper mb="lg" p="lg" shadow="md">
                            <Text size="md" weight="bold">{item.title}</Text>
                            {item.location && <Text size="md" color="gray">{item.location}</Text>}
                            <Group style={{justifyContent: 'space-between'}} mt="md">
                                <Text color="gray" size="sm">{[
                                    item.start ? moment(item.start).format("DD/MM/YYYY HH:mm") : null,
                                    item.finish ? moment(item.finish).format("DD/MM/YYYY HH:mm") : null
                                ].filter(nn => nn).join(" - ")}</Text>
                                <Badge color={item.origin === "senado" ? "blue" : "green"}>
                                    {item.origin === "senado" ? "Senado Federal" : "Câmara dos Deputados"}
                                </Badge>
                            </Group>
                        </Paper>)}
                    </Grid.Col>
                </Grid>
            </div>
                // <Table 
                //     data={data}
                //     columns={COLUMNS}
                //     error={error}
                //     loading={loading}
                //     actions={[
                        
                //     ]}
                // />
            }

            {viewMode === 'calendar' && 
            <Paper p="sm" mt="md">
                <Calendar
                    data={data.map(item => ({
                        color: item.origin === "senado" ? '#339AF0' : '#51CF66',
                        datetime: moment(item.start).format(),
                        content: [item.title, item.location].filter(nn => nn).join(" - ")
                    }))}
                    onChangePeriod={(period) => setFilters(f => ({...f, period}))}
                    onItemClick={(item) => {

                    }}
                />
            </Paper>
        }
    </>
}

export default React.forwardRef(List);